import React, { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import './App.css';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;
console.log(supabaseKey);
const supabase = createClient(supabaseUrl, supabaseKey);

function App() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [event, setEvent] = useState(null);

  const [eventId, setEventId] = useState('');
  const [reservationSuccess, setReservationSuccess] = useState(false);
  const [numPeople, setNumPeople] = useState(1); // Default value is 1

  useEffect(() => {
    console.log("fetching event", eventId)
    const fetchEvent = async () => {
      try {
        const { data, error } = await supabase
          .from('events')
          .select('*')
          .eq('id', eventId)
          .single();

        if (error) {
          throw error;
        }

        setEvent(data);
        console.log(data);
      } catch (error) {
        console.error('Error fetching event:', error.message);
      }
    };

    //if eventId is int not string
    if (Number.isInteger(parseInt(eventId))) {
      fetchEvent();
      
    }



   

   

    // Cleanup function to cancel fetch in case of component unmounting
    return () => {
      // Your cleanup logic here
    };
  }, [eventId]);
  

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const eventIdParam = urlParams.get('eventId');
    if(eventIdParam){
      console.log(eventIdParam);
      setEventId(eventIdParam);
    }
    
    //load event with it eventIdParam from supabase table events






  }  
  , []);
  const callEdgeFunction = async () => {
    try {
      // Call the Edge function
        const { data, error } = await supabase.functions.invoke('reservation-made', {
          body: { 
            eventId,
            name,
            email,
            numPeople
          },
        })

      if (error) {
        console.error('Error calling Edge function:', error.message);
      } else {
        console.log('Result of Edge function:', data);
        // Do something with the result if needed
      }
    } catch (error) {
      console.error('Error calling Edge function 123:', error.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      callEdgeFunction();
      setReservationSuccess(true);
      // const { data, error } = await supabase
      //   .from('reservations')
      //   .insert([{ name, email }]);
      // if (error) {
      //   throw error;
      // }
      // setReservationSuccess(true);
    } catch (error) {
      console.error('Error saving reservation:', error.message);
    }
  };

  const handleReset = () => {
    setName('');
    setEmail('');
    setReservationSuccess(false);
  };

  const goBackToWebsite = () => {
      window.history.back();
  };

  if (!event) {
    return <div>Loading...</div>;
  }

  return (
    <div className="App">
      <div className="container">
        <h1>Reservierung</h1>
        {!reservationSuccess ? (
          <>
            <div className="reservation-details">
              <h2>{event.title}</h2>
              <p>Schlossallee 1</p>
              <p>{event.start_date}</p>
              <p>{event.start_time}</p>
            </div>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <input
                type="email"
                placeholder="E-Mail-Adresse"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
                            <select
                value={numPeople}
                onChange={(e) => setNumPeople(parseInt(e.target.value))}
              >
                {[...Array(10).keys()].map((num) => (
                  <option key={num + 1} value={num + 1}>
                    {num + 1} Person{num !== 0 ? 'en' : ''}
                  </option>
                ))}
              </select>
              <input type="submit" value="Jetzt reservieren"/>

            </form>
          </>
        ) : (
          <div className="success-view">
            <p className="success-message">Erfolgreich!</p>
            <button onClick={handleReset}>Noch eine Reservierung machen</button>  <br/>
            <button style={{backgroundColor: "#4337ed"}} onClick={goBackToWebsite}>Zurück zur Website</button>  
          </div>
        )}
      </div>
    </div>
  );
}

export default App;